import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminAnalytics from "@/pages/admin/AdminAnalytics";
import AdminContent from "@/pages/admin/AdminContent";
import AdminMessages from "@/pages/admin/AdminMessages";
import AdminVisits from "@/pages/admin/AdminVisits";
import { AuthProvider } from "@/lib/auth";

export const BUSINESS = {
  name: "Bangalore Paint Pros",
  phone: "+91 70190 56581",
  phoneRaw: "+917019056581",
  whatsapp: "917019056581",
  email: "hello@bangalorepaintpros.in",
  area: "Bangalore, India",
};

function AppRouter() {
  const location = useLocation();
  // CRITICAL: Detect session_id in URL fragment BEFORE any route renders.
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Navigate to="/admin/leads" replace />} />
        <Route path="leads" element={<AdminLeads />} />
        <Route path="visits" element={<AdminVisits />} />
        <Route path="analytics" element={<AdminAnalytics />} />
        <Route path="content" element={<AdminContent />} />
        <Route path="messages" element={<AdminMessages />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
